const dateFormats = {
  default: 'YYYY-MM-DD',
  shortDisplay: 'MMM DD, YYYY',
}

export default dateFormats
